import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Api from './api';
import * as Actions from './actions';

export const fetchInstitutionsObservables = institutionIds => {
    return Observable.zip(...institutionIds.map(id => Api.fetch(id))).map(institutions => {
        return Actions.fetchAllSuccess.action(institutions.map(i => i.institution));
    });
};

export const fetchOpeningHoursObservable = institutionId =>
    Api.fetchOpeningHours(institutionId).map(data =>
        Actions.fetchOpeningHoursSuccess.action({
            behaviors: data.behaviors,
            openingHours: data.openingHours,
            institutionId,
        }),
    );

export const fetchGroupsObservable = institutionId => {
    return Api.fetchGroups(institutionId).map(data =>
        Actions.fetchGroupsSuccess.action({
            groups: data,
            institutionId,
        }),
    );
};

const update = action$ =>
    action$.ofType(Actions.update.type).mergeMap(({payload}) =>
        Api.update(payload.institution)
            .map(data =>
                Actions.updateSuccess.action(
                    data.institution,
                    payload.privacyPolicyUrl,
                    payload.facebookLink,
                    payload.instagramLink,
                    payload.twitterLink,
                    payload.description,
                ),
            )
            .catch(e => Observable.of(Actions.updateFailed.action(e))),
    );

const fetchOpeningHours = action$ =>
    action$
        .ofType(Actions.fetchOpeningHours.type)
        .mergeMap(({payload}) =>
            fetchOpeningHoursObservable(payload.institutionId).catch(e =>
                Observable.of(Actions.fetchOpeningHoursFailed.action(e, payload.institutionId)),
            ),
        );

const updateOpeningHours = action$ =>
    action$.ofType(Actions.updateOpeningHours.type).mergeMap(({payload}) =>
        Api.updateOpeningHours(payload.institutionId, payload.openingHours)
            .flatMap(data => {
                return [
                    Actions.updateOpeningHoursSuccess.action({
                        openingHours: data,
                        institutionId: payload.institutionId,
                    }),
                    GlobalEventActions.updateSuccess.action(i18next.t('institution.openingHoursUpdated')),
                ];
            })
            .catch(e => Observable.of(Actions.updateOpeningHoursFailed.action(e, payload.institutionId))),
    );
const fetchGroups = action$ =>
    action$
        .ofType(Actions.fetchGroups.type)
        .mergeMap(({payload}) =>
            fetchGroupsObservable(payload.institutionId).catch(e =>
                Observable.of(Actions.fetchGroupsFailed.action(e, payload.institutionId)),
            ),
        );

export default combineEpics(update, fetchOpeningHours, updateOpeningHours, fetchGroups);
